<template>
  <div class="wallet-page" v-if="isLogin || true">
    <div class="content">
      <top-header></top-header>
      <top-banner :bannerImgName="'banner-wallet'"></top-banner>
      <slide-tip-bar
        v-if="isShowAdvertiseBar"
        class="advertise"
        :tip="''"
      ></slide-tip-bar>
      <div class="wallet">
        <p class="wallet-name">
          <span class="wallet-name-text">{{ getCoinsName }}</span>
          <em
            class="wallet-name-ask"
            @click="visibleCoinsAgreePopupHandle(true)"
          ></em>
        </p>
        <p class="wallet-balance">
          <span class="wallet-balance-pre">{{ letter.curBalance }}: </span>
          <span class="wallet-balance-center">{{
            isUidLogin ? '***' : curCoinAmount
          }}</span>
          <span class="wallet-balance-after">{{ curCoinCurrency }}</span>
        </p>
        <a
          href="javascript:;"
          class="wallet-pay"
          v-if="visibleWalletPay"
          @click="goToCoinsPage"
          >{{ letter.goToPay }}</a
        >
        <a
          href="javascript:;"
          class="wallet-change"
          v-if="showChangeCoinBtn"
          @click="changeCoinType"
          >{{ letter.changeCoin }}</a
        >
      </div>
      <div class="coupon" v-if="isShowTopCoupon">
        <p class="coupon-title">{{ letter.couponMyQuan }}</p>
        <p class="coupon-number">
          {{
            letter.couponValidQuanTip.replace(
              '${num}',
              gameCouponEnableList.length
            )
          }}
        </p>
        <a
          href="javascript:;"
          class="coupon-desc j-click-top-my-coupon"
          @click="showGameCouponPopup"
          >{{ letter.storeLookDetail }}</a
        >
        <!-- vip积分入口 -->
        <a
          v-if="isVipScore"
          href="javascript:;"
          class="coupon-more"
          @click="goToVipActivityPage"
          >{{ letter.getMore }}</a
        >
      </div>
    </div>
    <coins-selector
      class="area-selector"
      v-if="showCoinsSelector"
      :showChildSelector="showCoinsSelector"
      :curBalanceItem="{
        amount: curCoinAmount,
        currency: curCoinCurrency
      }"
      :balanceList="balanceList"
      @closeSelecter="showCoinsSelector = false"
      @hideCoinsSelector="hideCoinsSelector"
    ></coins-selector>
    <page-footer></page-footer>
    <transition name="fade" mode="out-in">
      <Loading v-show="loading"></Loading>
    </transition>
    <transition name="fade">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :activeId="gameActiveCouponId"
        :showItemUseBtn="isShowGameItemUseBtn"
        @closeCouponPopup="hideGameCouponPopup"
      ></coupon-list-popup>
    </transition>
    <coins-agree-popup
      v-bind:visible.sync="visibleCoinsAgreePopup"
    ></coins-agree-popup>
    <PopupWindow
      v-if="visibleBzitNotice"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="bzitNoticeTitle"
      :content="bzitNoticeContent"
      :autoHeight="true"
      @onConfirm="closeBzitNotice"
      @onCancel="closeBzitNotice"
    ></PopupWindow>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import coupon from '@mixins/officialStore/coupon';
import coinsAgree from '@mixins/officialStore/coinsAgree';
import allStorePopup from '@mixins/allStorePopup';
import TopBanner from '@components/officialStore/TopBanner.vue';
import TopHeader from '@components/officialStore/TopHeader.vue';
import PageFooter from '@components/officialStore/PageFooter.vue';
import SlideTipBar from '@components/officialStore/common/SlideTipBar.vue';
import CouponListPopup from '@components/officialStore/coupon/CouponListPopup.vue';
import CoinsAgreePopup from '@components/officialStore/coins/CoinsAgreePopup.vue';
import Loading from '@components/officialStore/Loading.vue';
import CoinsSelector from '@components/officialStore/coins/CoinsSelector';
import { getLocaLclStor } from '@store/officialStore/storager';
import {
  GET_BALANCE_INIT_DATA,
  GET_BALANCE_USER_DATA,
  UPDATE_COIN,
  UPDATE_DEFAULT_CURRENCY,
  getAreaByCurrency
} from '@store/officialStore/coins';

export default {
  name: 'Wallet',
  mixins: [coupon, coinsAgree, allStorePopup],
  data() {
    return {
      showCoinsSelector: false,
      locations: getLocaLclStor(),
      visibleWalletPay:
        new Date().getTime() < new Date('2025-08-18 00:00:00Z').getTime()
    };
  },
  computed: {
    ...mapState({
      loading: state => state.loading,
      isLogin: state => state.login.isLogin,
      isUidLogin: state => state.login.isUidLogin,
      gameId: state => state.gameId,
      letter: state => state.letter,
      isShowGameCouponEntry: state => state.coupon.isShowGameCouponEntry,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isUidTypeAndHideVipCoupon: state => state.login.isUidTypeAndHideVipCoupon,
      curCoinAmount: state => state.coins.curCoinAmount,
      curCoinCurrency: state => state.coins.curCoinCurrency,
      balanceList: state => state.coins.balanceList
    }),
    ...mapGetters(['isJpPlatform', 'getCoinsName', 'gameInfoConfig']),
    isShowTopCoupon() {
      return this.gameInfoConfig.isHeaderCoupon;
    },
    isVipScore() {
      return this.gameInfoConfig.isVipScore;
    },
    showChangeCoinBtn() {
      return (
        this.balanceList.length &&
        this.balanceList.length >= 2 &&
        !this.isJpPlatform
      );
    },
    isShowAdvertiseBar() {
      return this.gameInfoConfig.isShowAdvertiseBar;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newVal) {
        // 每次进入钱包页面都更新一下数据
        newVal.name === 'wallet' && this.init();
      }
    }
  },
  methods: {
    init() {
      this.loadGameCouponList();
      this.loadBalanceUserData();
    },
    async loadBalanceUserData() {
      await this.$store.dispatch(GET_BALANCE_USER_DATA);
    },
    async goToCoinsPage() {
      let location = getAreaByCurrency(this.curCoinCurrency);
      if (this.isJpPlatform) {
        location = 'JP';
      }
      await this.$store.dispatch(GET_BALANCE_INIT_DATA, {
        location
      });
      await this.$store.dispatch(GET_BALANCE_USER_DATA);
      this.$router.push({ name: 'coins' });
    },
    goToVipActivityPage() {
      this.$router.push({
        name: 'vipScore'
      });
    },
    changeCoinType() {
      this.showCoinsSelector = true;
    },
    hideCoinsSelector(balanceItem) {
      this.$store.commit(UPDATE_COIN, {
        amount: balanceItem?.amount,
        currency: balanceItem?.currency
      });
      this.$store.commit(UPDATE_DEFAULT_CURRENCY, balanceItem?.currency);
      this.showCoinsSelector = false;
    }
  },
  components: {
    TopBanner,
    TopHeader,
    PageFooter,
    SlideTipBar,
    CouponListPopup,
    CoinsAgreePopup,
    Loading,
    CoinsSelector
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.wallet-page {
  position: relative;
  float: left;
  display: block;
  width: 100% !important;
  height: auto !important;
  min-height: 100%;
  background-position: top center;
  background-color: #111114;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  @psetbg ("bg.png");
}

.content {
  position: relative;
  margin-bottom: 200px;
}

.advertise {
  margin-bottom: 36px;
}

.wallet,
.coupon {
  width: 660px;
  margin: auto;
  border: 1px solid #8e8e8e;
  background-color: #000000;
}

.wallet {
  overflow: hidden;
  height: 380px;
  margin-bottom: 36px;
  font-weight: bold;
  color: #ffffff;
  &-name {
    position: relative;
    display: inline-block;
    margin: 64px auto 32px;
    &-text {
      font-size: 30px;
    }
    &-ask {
      position: absolute;
      top: -90%;
      right: -34px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      @psetbg ("use-coin-ask.png");
    }
  }
  &-balance {
    margin-bottom: 50px;
    &-pre {
      font-size: 36px;
    }
    &-center {
      font-size: 56px;
      color: #c1a15e;
    }
    &-after {
      margin-left: 16px;
      font-size: 28px;
    }
  }
  &-pay {
    display: block;
    margin: 0 auto 16px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 34px;
    line-height: 74px;
    color: #ffffff;
    @psetbg ("wallet-pay-active.png");
  }
  &-change {
    padding-bottom: 4px;
    border-bottom: 1px solid #b99753;
    font-weight: normal;
    font-size: 24px;
    color: #b99753;
  }
}

.coupon {
  overflow: hidden;
  height: 400px;
  font-weight: bold;
  color: #fff;
  &-title {
    margin: 44px auto 18px;
    font-size: 36px;
  }
  &-number {
    margin-bottom: 32px;
    font-size: 36px;
    color: #fff;
  }
  &-desc,
  &-more {
    display: block;
    margin: auto;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 34px;
    line-height: 74px;
    color: #ffffff;
  }
  &-desc {
    margin-bottom: 20px;
    @psetbg ("wallet-desc-active.png");
  }
  &-more {
    margin-bottom: 16px;
    @psetbg ("wallet-more-active.png");
  }
}

.area-selector ::v-deep .select-wrapper {
  left: 0;
}

@media screen and (orientation: landscape) {
  .title {
    margin-top: -90px;
  }
}
</style>
